import { prioritySchema } from "@repro/shared";
import { z } from "zod";

/** Inbox URL search params: shareable filters and the page cursor. */
export const inboxSearchSchema = z.object({
  projectId: z.string().uuid().optional().catch(undefined),
  priority: z
    .union([z.array(prioritySchema), prioritySchema.transform((value) => [value])])
    .optional()
    .catch(undefined),
  failed: z.boolean().optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});
